import { PanelToggles } from '@frameio/app-header/components/PanelToggles';
import type { PanelLayout } from '@frameio/shared/contexts/PanelLayoutContext/types';
import { useCurrentPageType } from '@frameio/shared/routing/getPageType';
import type { PageType } from '@frameio/shared/routing/types';

/**
 * Renders the panel toggles component with the correct panel layout based on the current page type
 */
export function HeaderPanelToggles() {
  const pageType = useCurrentPageType();
  const panelLayout = getPanelLayoutForPanelToggles(pageType);

  return panelLayout && <PanelToggles panelLayout={panelLayout} />;
}

/**
 * normalizes the page type to the correct panel layout for the panel toggles component
 */
function getPanelLayoutForPanelToggles(pageType: PageType): PanelLayout | null {
  if (pageType === 'finder' || pageType === 'folder') return 'project';
  if (pageType === 'folderViewer') return 'viewer';
  return null;
}
